import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  value: "-1"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_vorschadenFHHUG = _resolveComponent("vorschadenFHHUG")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_zeile, { class: "u-mar-t-1" }, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.vorschadenFrage), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_zelle, { breite: 3 }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.vorschaedenAnzahl) = $event)),
              id: "hugvorschaedenAnzahl",
              name: "hugvorschaedenAnzahl",
              "data-cy": "hugtariffNumberOfPredamages",
              class: "c-form-control-select",
              required: "",
              "aria-required": "true",
              "aria-label": "Anzahl Vorschäden",
              "data-fehlermeldung": "Bitte wählen Sie die Anzahl der Vorschäden aus."
            }, [
              (_ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.vorschaedenAnzahl === -1)
                ? (_openBlock(), _createElementBlock("option", _hoisted_1, " Bitte wählen Sie "))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("option", { value: "0" }, "0", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("option", { value: "1" }, "1", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("option", { value: "2" }, "2", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("option", { value: "3" }, "3", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("option", { value: "4" }, "4", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("option", { value: "5" }, "5 oder mehr", -1))
            ], 512), [
              [
                _vModelSelect,
                _ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.vorschaedenAnzahl,
                void 0,
                { number: true }
              ]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.hugvorschaedenAnzahl,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.vorschaedenAnzahl >= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.piniaStore.state.ferienhaus.hug.tarifinformationen.vorschaedenAnzahl, (vorschadenId) => {
            return (_openBlock(), _createBlock(_component_vorschadenFHHUG, {
              key: vorschadenId,
              vorschadenId: vorschadenId,
              fehler: _ctx.fehler,
              "zeige-schadenart": _ctx.zeigeSchadenart,
              sparte: "hug"
            }, null, 8, ["vorschadenId", "fehler", "zeige-schadenart"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}